import React from 'react';
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Tooltip
} from '@mui/material';
import ColorLensIcon from '@mui/icons-material/ColorLens';

const ColorPresets = ({ onColorSelect }) => {
  const colorPresets = [
    '#1976d2', '#2e7d32', '#ed6c02', '#d32f2f', '#7b1fa2', '#0288d1',
    '#0052cc', '#388e3c', '#f57c00', '#c2185b', '#512da8', '#0097a7',
    '#1976d2', '#c62828', '#ad1457', '#6a1b9a', '#283593', '#1565c0',
    '#00838f', '#2e7d32', '#558b2f', '#9e9d24', '#f9a825', '#ff8f00'
  ];

  return (
    <Box>
      <Typography variant="h6" gutterBottom display="flex" alignItems="center" gap={1}>
        <ColorLensIcon color="primary" />
        Color Presets
      </Typography>
      
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Click to apply preset colors
      </Typography>
      
      <Grid container spacing={1}>
        {colorPresets.map((color, index) => (
          <Grid item xs={3} sm={2} key={index}>
            <Tooltip title={color} arrow>
              <IconButton
                sx={{
                  width: '100%',
                  height: 40,
                  backgroundColor: color,
                  border: '2px solid',
                  borderColor: 'background.paper',
                  boxShadow: 1,
                  '&:hover': {
                    transform: 'scale(1.1)',
                    backgroundColor: color,
                    boxShadow: 3
                  }
                }}
                onClick={() => onColorSelect({ hex: color })}
              />
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ColorPresets;